import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getUsers } from "./../../REDUX/Models/users.Model";
import { getCategories, getHomeSkills } from "../../REDUX/Models/skills.Model";
import { getCurriculums } from "../../REDUX/Models/curriculums.Model";
import main from "./../../assets/icons/main.svg";
import section from "./../../assets/icons/skills.svg";
import vault from "./../../assets/imgs/vault.png";
import "./index.scss";

export default function Home() {
  const texts = [
    "اكتشف مهارات جديدة",
    "تواصل مع المدربين",
    "تعلم عن بعد",
    "اربح جوائز قيمة",
    "انشر مهاراتك الان",
  ];
  const [newText, setNewText] = useState("ابدأ الأن .");
  const [motion, setMotion] = useState("none");
  const [skills, setSkills] = useState([]);
  const [categories, setCategories] = useState([]);
  const [curriculums, setCurriculums] = useState([]);
  const [users, setUsers] = useState([]);
  const [hidden, setHidden] = useState(true);

  const navigate = useNavigate();

  const handleClick = (id) => {
    getHomeSkills({ category: id })
      .then((res) => {
        setSkills(res.data.skills);
        setHidden(false);
      })
      .catch(() => {
        alert("خطأ");
      });
  };

  useEffect(() => {
    let index = 0;
    const shuffledTexts = [...texts].sort(() => Math.random() - 0.5);

    const interval = setInterval(() => {
      setMotion("none");

      setTimeout(() => {
        setNewText(shuffledTexts[index]);
        setMotion("motion");
        index = (index + 1) % shuffledTexts.length;
      }, 1000);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    document.title = `طورنى - الرئيسية`;
    getUsers().then((res) => {
      setUsers(res.data.users.length);
    });
    getCategories().then((res) => {
      setCategories(res.data.categories.length);
    });
    getCurriculums().then((res) => {
      setCurriculums(res.data.curriculums.length);
    });
  });

  return (
    <div className="home">
      <div className="container">
        <div className="row">
          <div className="main-text">
            <h2>
              طــورنــى: <span className={motion}>{newText}</span>
            </h2>
            <p>
              يمكنك الأن التواصل مع المدربين في مختلف المهارات من جميع انحاء
              الوطن العربي.
            </p>
            <div className="analytics">
              <div className="row">
                <span>
                  <i className="fa-light fa-chalkboard-user"></i>
                  <p> +{curriculums} مدرب</p>
                </span>
                <span>
                  <i className="fa-light fa-graduation-cap"></i>
                  <p> +{categories} تخصص</p>
                </span>
                <span>
                  <i className="fa-light fa-user"></i>
                  <p> +{users} مستخدم</p>
                </span>
              </div>
            </div>
            <button onClick={() => navigate("/login")}>ابدأ الأن</button>
          </div>
          <div className="main-img">
            <img src={main} alt="Main Hero Image" />
          </div>
        </div>
      </div>
      <div className="section">
        <div className="row">
          <div className="section-text">
            <h2>المنصة الأولى في الوطن العربى في فكرتها.</h2>
            <p>
              مع طورنى يمكنك التواصل مع العديد من المدربين والمتخصصين في جميع
              انحاء الوطن العربي للتعلم عن بعد واستكشاف المهارات التقنية والغير
              التقنية .. تصفح اقسام المنصة الأن او ابدأ معنا كا مدرب وساعد في
              نشر العلم مع الكثير من المستخدمين واحصل على العديد من الجوائز
              القيمة.
            </p>
            <button onClick={() => navigate("/login")}>
              ابدأ الأن مع طورنى
            </button>
          </div>
          <div className="section-img imgl">
            <img src={section} alt="section-img" />
          </div>
        </div>
      </div>
      <div className="section-fw">
        <h2>جرب التعلم مع طورنى</h2>
        <p>
          مع طورنى انت على بعد خطوة واحدة من تعلم مهارة جديدة يمكنك الاختيار بين
          اكثر التخصصات طلبًا في سوق العمل العربي.
        </p>
        <div className="row">
          <span onClick={() => handleClick("ادارية")}>
            <i className="fa-light fa-pen-line"></i>
            <p> مهارات ادارية</p>
          </span>
          <span onClick={() => handleClick("تقنية")}>
            <i className="fa-light fa-code"></i>
            <p> مهارات تقنية</p>
          </span>
          <span onClick={() => handleClick("فنية")}>
            <i className="fa-light fa-camera"></i>
            <p> مهارات فنية</p>
          </span>
        </div>
        <div className="content" style={{ display: hidden ? "none" : "flex" }}>
          <div className="skills">
            {skills.map((skill, index) => {
              return (
                <Link to={`/category/${skill.category}`} key={index}>
                  <div className="skill-box">
                    <i className="fa-duotone fa-shapes"></i>
                    <p>{skill.name}</p>
                  </div>
                </Link>
              );
            })}
          </div>
          {skills.length > 0 ? (
            <button onClick={() => navigate(`/category/${skills[0].category}`)}>
              عرض الكل
            </button>
          ) : (
            ""
          )}
        </div>
        <button onClick={() => navigate("/categories")}>تصفح التخصصات</button>
      </div>

      <div className="section circle-avatars">
          <h2>مستخدمون مميزون على المنصة</h2>
          <div className="avatars-ring">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <img
                key={i}
                src={`./avatars/${i}.png`}
                alt="User Avatar"
                className={`avatar avatar-${i}`}
              />
            ))}
          </div>
          <button onClick={() => navigate("/register")}>انضم الينا</button>
      </div>

      <div className="section">
        <div className="row">
          <div className="section-img">
            <img src={vault} alt="section-img" />
          </div>
          <div className="section-text">
            <h2>سجل مع طورنى الأن واحصل على جوائز قيمة.</h2>
            <p>
              سجل مع منصة طورنى وساهم في نشر العلم والمهارات على مستوى الوطن
              العربي وساعد الكثير على تطوير مهاراتهم وقدراتهم في المجال المفضل
              اليك واحصل على مكافأت وجوائز قيمة.
            </p>
            <button onClick={() => navigate("/register")}> سجل الأن</button>
          </div>
        </div>
      </div>

      <div className="section animated-svgs">
          <h2>تعلم بشكل ممتع وتفاعلي</h2>
          <p>
            مع طورنى، ستجد أن العملية التعليمية ليست مملة، بل مليئة بالحيوية
            والمتعة.
          </p>
          <div className="svg-icons">
            <svg
              className="animated-icon bounce"
              width="80"
              height="80"
              fill="#1f4d33"
              viewBox="0 0 24 24"
            >
              <path d="M12 2L15 8H9L12 2ZM4 22H20L12 13L4 22Z" />
            </svg>
            <svg
              className="animated-icon pulse"
              width="80"
              height="80"
              fill="#fbb03b"
              viewBox="0 0 24 24"
            >
              <circle cx="12" cy="12" r="10" />
            </svg>
            <svg
              className="animated-icon spin"
              width="80"
              height="80"
              fill="#1f4d33"
              viewBox="0 0 24 24"
            >
              <rect x="4" y="4" width="16" height="16" rx="2" />
            </svg>
          </div>
          <button onClick={() => navigate("/register")}> ابدأ رحلتك</button>
      </div>
    </div>
  );
}
